
































import { Component, Vue, Prop } from "vue-property-decorator";
import { yandexMap, ymapMarker } from 'vue-yandex-maps';
import { ConfigApi } from "fs-pb-vue2/services/api/ConfigApi";
import { MapData } from "fs-pb-vue2/data/mapData";
import Preloader from "@/components/app/Preloader.vue";

@Component({ components: { yandexMap, ymapMarker, Preloader }})
export default class MapComponent extends Vue {

  markerType: string = 'all';

  markerTypes: Array<any> = [
    {
        label: 'Офисы и банкоматы',
        value: 'all'
    },
    {
        label: 'Офисы',
        value: 'office'
    },
    {
        label: 'Банкоматы',
        value: 'atm'
    }
  ];

  coords: Array<any> = [
    46.19850705885551,
    33.81434286865233,
  ];

  mapData: MapData = null;

  mapLoading: boolean = false;

  settings: any = {
    apiKey: '720e664b-d70f-4bb2-a2f4-3eec62b75e86',
    lang: 'ru_RU',
    coordorder: 'latlong',
    enterprise: false,
    version: '2.1'
  };

  get companies(): Array<any> {
    const companies: Array<any> = 
      this.mapData.Companies.filter((comp: any) => (comp.Type === 'office' || comp.Type === 'atm') && comp.Adress.length);
    if (this.markerType === 'all' || !this.markerType)
      return companies;
    else
      return companies.filter((comp: any) => comp.Type === this.markerType);
  }

  // markerIcon(type: string): string {
  //   const res: any = {
  //     layout: 'default#imageWithContent',
  //     imageHref: require('./../../../public/img/greenPLCH.png'),
  //     imageSize: [32, 32],
  //     imageOffset: [0, 0],
  //     content: '',
  //     contentOffset: [0, 15],
  //     contentLayout: ''
  //   };

  //   switch (type) {
  //     case 'office':
  //       res.imageHref = require('./../../../public/img/greenPLCH.png');
  //       break;
  //     case 'atm':
  //       res.imageHref = require('./../../../public/img/bluePLCH.png');
  //       break;
  //     default:
  //       res.imageHref = require('./../../../public/img/bluePLCH.png');
  //       break;
  //   }
  //   return res;
  // }
  
  async mounted() {
    // await loadYmap(this.settings);
    this.mapLoading = true;
    try {
      this.mapData = await ConfigApi.getMapData();
      if (this.mapData.Companies.length > 0) {
        this.coords = this.mapData.Companies[0].Cords;
      }
    } catch(e: any) {
      console.warn(e);
    } finally {
      this.mapLoading = false;
    }
  }

}
